import { getUuid } from '@/utils/commonUtil'
import { getDateYYYYMMDDHHMISS } from '@/utils/dateUtil'
import config from '@/conf/config'

export function getHeader() {
    const token = localStorage.getItem('token')
    let authorization = ""
    if (token) {
        authorization = `Bearer ${token}`
    }
    // 从 localStorage 获取用户信息
    const userInfo = JSON.parse(localStorage.getItem('user') || '{}')
    const userId = userInfo.userId || '-1'
    // 从 localStorage 获取 storeId
    const storeInfo = JSON.parse(localStorage.getItem('storeInfo') || '{}')
    const storeId = storeInfo.storeId || ''
    
    return {
        Authorization: authorization,
        'app-id': config.appId,
        'TRANSACTION-ID': getUuid(),
        'REQ-TIME': getDateYYYYMMDDHHMISS(),
        'SIGN': '',
        'user-id': userId,
        'store-id': storeId
    }
}